import * as React from 'react';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {CarAccelerationDataframeDto} from 'Models/CollisionModel';
import {HistoryCollisionSelectors} from 'Redux/Selectors/CollisionSelectors';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {HistoryCarArrow} from 'components/History/HistoryCarArrow';

enum HistoryCarViewEnum {
    VIEW_3D = "VIEW_3D",
    VIEW_FRONT = "VIEW_FRONT",
    VIEW_BACK = "VIEW_BACK",
    VIEW_TOP = "VIEW_TOP",
    VIEW_BOTTOM = "VIEW_BOTTOM",
    VIEW_LEFT = "VIEW_LEFT",
    VIEW_RIGHT = "VIEW_RIGHT",
}

interface IState {
    activeView: HistoryCarViewEnum,
    viewClass: string
}

type ConnectedProps = {
    acceleration: Array<CarAccelerationDataframeDto>,
    activeAccelerationDataframe: CarAccelerationDataframeDto,
    activeAccelerationVectorRotate: {
        alfa: number,
        beta: number,
        gamma: number,
        length: number
    }
};

type Props = {
    t?: any
};

export class HistoryCar extends React.Component<Props & ConnectedProps, IState> {

    constructor(props: any) {
        super(props);

        this.setActiveView.bind(this);

        this.state = {
            activeView: HistoryCarViewEnum.VIEW_3D,
            viewClass: "show-frontRight"
        }
    }

    private onClickView3D = () => this.setActiveView(HistoryCarViewEnum.VIEW_3D);
    private onClickViewFront = () => this.setActiveView(HistoryCarViewEnum.VIEW_FRONT);

    private setActiveView(view: HistoryCarViewEnum) {
        let viewClass = '';

        switch (view) {
            case HistoryCarViewEnum.VIEW_FRONT:
                viewClass = 'show-front';
                break;
            case HistoryCarViewEnum.VIEW_BACK:
                viewClass = 'show-back';
                break;
            case HistoryCarViewEnum.VIEW_LEFT:
                viewClass = 'show-left';
                break;
            case HistoryCarViewEnum.VIEW_RIGHT:
                viewClass = 'show-right';
                break;
            case HistoryCarViewEnum.VIEW_3D:
                viewClass = 'show-frontRight';
                break;
            case HistoryCarViewEnum.VIEW_TOP:
                viewClass = 'show-top';
                break;
            case HistoryCarViewEnum.VIEW_BOTTOM:
                viewClass = 'show-bottom';
                break;
            default:
                viewClass = 'show-front';
        }

        this.setState({
            activeView: view,
            viewClass
        })
    }

    private addClass(view: HistoryCarViewEnum) {
        if (view == this.state.activeView) {
            return 'historyCar__button--active'
        }

        return '';
    }

    public render() {
        const {t, activeAccelerationVectorRotate} = this.props;
        const voctorRotate = activeAccelerationVectorRotate;

        const style = {
            transform: `rotateX(${voctorRotate.alfa}deg) rotateZ(${voctorRotate.beta}deg) rotateY(${voctorRotate.gamma}deg) scale(${voctorRotate.length},1)`
        };

        return (
            <div className="historyCar">
                <div className="historyCar__tool">
                    <div
                        className={`historyCar__button historyCar__button--3d ${this.addClass(HistoryCarViewEnum.VIEW_3D)}`}
                        onClick={this.onClickView3D}>3D
                    </div>
                    <div
                        className={`historyCar__button historyCar__button--front ${this.addClass(HistoryCarViewEnum.VIEW_FRONT)}`}
                        onClick={this.onClickViewFront}>{t('front')}
                    </div>
                    <div
                        className={`historyCar__button historyCar__button--side ${this.addClass(HistoryCarViewEnum.VIEW_BACK)}`}
                        onClick={() => this.setActiveView(HistoryCarViewEnum.VIEW_BACK)}>{t('back')}
                    </div>
                    <div
                        className={`historyCar__button historyCar__button--side ${this.addClass(HistoryCarViewEnum.VIEW_LEFT)}`}
                        onClick={() => this.setActiveView(HistoryCarViewEnum.VIEW_LEFT)}>{t('left')}
                    </div>
                    <div
                        className={`historyCar__button historyCar__button--side ${this.addClass(HistoryCarViewEnum.VIEW_RIGHT)}`}
                        onClick={() => this.setActiveView(HistoryCarViewEnum.VIEW_RIGHT)}>{t('right')}
                    </div>
                    <div
                        className={`historyCar__button historyCar__button--side ${this.addClass(HistoryCarViewEnum.VIEW_TOP)}`}
                        onClick={() => this.setActiveView(HistoryCarViewEnum.VIEW_TOP)}>{t('top')}
                    </div>
                    <div
                        className={`historyCar__button historyCar__button--side ${this.addClass(HistoryCarViewEnum.VIEW_BOTTOM)}`}
                        onClick={() => this.setActiveView(HistoryCarViewEnum.VIEW_BOTTOM)}>{t('bottom')}
                    </div>
                </div>

                <div className={"scene"}>

                    <div className={"cube " + this.state.viewClass}>
                        <HistoryCarArrow style={style}/>
                        <div className="cube__face cube__face--front">{t('front')}</div>
                        <div className="cube__face cube__face--back">{t('back')}</div>
                        <div className="cube__face cube__face--right">{t('right')}</div>
                        <div className="cube__face cube__face--left">{t('left')}</div>
                        <div className="cube__face cube__face--top">{t('top')}</div>
                        <div className="cube__face cube__face--bottom">{t('bottom')}</div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        acceleration: HistoryCollisionSelectors.getDataframesAcceleration(state),
        activeAccelerationDataframe: HistoryCollisionSelectors.getActiveAccelerationDataframe(state),
        activeAccelerationVectorRotate: HistoryCollisionSelectors.getActiveAccelerationVectorRotate(state)
    };
}

export default withTranslation(['reports'])(connect(
    mapStateToProps,
    null
)(HistoryCar) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/History/HistoryCar.tsx